import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
const Description = ({ children, classNames }) => {
    const classes = clsx('max-w-[558px] text-center text-small text-neutral-500', classNames);
    return _jsx("p", { className: classes, children: children });
};
export default Description;
